const AORStatuses = {
    // String-based statuses (legacy)
    registered: {
        type: 'active',
        displayedName: 'Registered',
        toolTip: 'AOR is successfully registered',
    },
    unregistered: {
        type: 'inactive',
        displayedName: 'Unregistered',
        toolTip: 'AOR is not currently registered',
    },
    failed: {
        type: 'error',
        displayedName: 'Failed',
        toolTip: 'AOR registration failed',
    },

    // Numeric statuses for TRS Registrations
    0: {
        type: 'active',
        displayedName: 'OK',
        toolTip: 'Registration is active and ready for use',
    },
    4: {
        type: 'processing',
        displayedName: 'Processing',
        toolTip: 'Registration is being processed',
    },
    20: {
        type: 'error',
        displayedName: 'Error',
        toolTip: 'Registration encountered an error',
    },

    // Default fallback for unknown statuses
    default: {
        type: 'disabled',
        displayedName: 'Unknown',
        toolTip: 'Unknown status',
    },
};

export default AORStatuses;
